import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";

export const toggleUnitAuthorization = async (unitId: number): Promise<any> => {
  const { data } = await axiosClient.post(
    `${ENDPOINTS.BASE_UNITS}/${unitId}/authorization`
  );

  return data;
};
